












import { Component, Prop, Vue } from 'vue-property-decorator'
import { cardWHtoStyle, iconPath, defaultDeck } from '@/lib'

const emptyDeck: Deck = {
  ...defaultDeck(),
  id: '_add_deck',
  name: 'create new deck',
  color: 'transparent',
  icon: 'plus'
}

@Component
export default class DeckCover extends Vue {
  @Prop({ default () { return emptyDeck } }) public readonly deck!: Deck

  private get icon () {
    const icon = this.deck.icon || 'default'
    return iconPath(icon)
  }

  private get style () {
    return {
      backgroundColor: this.deck.color,
      ...cardWHtoStyle(this.deck.cardWidth, this.deck.cardHeight)
    }
  }
}
